import { Form, Formik } from "formik";
import { motion } from "framer-motion";
import { putApi } from "../../../../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
} from "../../../../../utils/toastify-message/ToastifyMessage";
import Input from "../../../../common/inputs/Input";
import TextArea from "../../../../common/inputs/TextArea";
import Select from "../../../../common/inputs/Select";
import { useContext } from "react";
import { context } from "../../../../../context/context";

function Information({ data, allData }) {
  const { utils } = useContext(context);

  const formHandler = async (values) => {
    const path = `admin/loans/${allData?._id}/loanGuarantors`;
    const body = values;
    console.log(body);
    try {
      await putApi({ path, body });
      successMessage("اطلاعات ضامن با موفقیت ویرایش شد.");
    } catch (error) {
      console.log(error);
      errorMessage(error?.response?.data?.errors[0]?.message);
    }
  };
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 0.5,
        // ease: [0, 0.71, 0.2, 1.01]
      }}
      className="w-11/12 mx-auto  border border-gray-200 rounded-lg my-6 bg-white dark:bg-[#060d26] shadow-sm p-6"
    >
      <h3 class="mb-4 text-lg font-medium leading-none text-gray-900 dark:text-white">
        مشخصات
      </h3>
      <Formik
        enableReinitialize
        initialValues={{
          nationalId: data?.nationalId || "",
          mobile: data?.mobile || "",
          status: data?.status || "",
          bankAccountId: data?.bankAccountId || "",
          job: data?.job || "",
          jobDescription: data?.jobDescription || "",
        }}
        onSubmit={formHandler}
      >
        {() => (
          <Form>
            <div className="mt-6">
              <div className="grid gap-6 mb-6 md:grid-cols-2">
                <Input
                  name="nationalId"
                  placeholder="شماره ملی"
                  label="شماره ملی"
                  type="text"
                />
                <Input
                  name="mobile"
                  placeholder="شماره"
                  label="شماره"
                  type="text"
                />
                <Input
                  name="bankAccountId"
                  placeholder="شماره حساب"
                  label="شماره حساب"
                  type="text"
                />
                <Input name="job" placeholder="شغل" label="شغل" type="text" />{" "}
                
                <Select
                  name="status"
                  placeholder="وضعیت ضامن"
                  label="وضعیت ضامن"
                >
                  <option>انتخاب وضعیت</option>
                  {utils?.LOAN_GUARANTOR_STATUS_VALUES?.length
                    ? utils?.LOAN_GUARANTOR_STATUS_VALUES.map((item) => {
                        return (
                          <option value={item?.value}>{item?.name}</option>
                        );
                      })
                    : null}
                </Select>
              </div>
              <div className="grid gap-4">
                <TextArea
                  name="jobDescription"
                  placeholder="توضیحات شغل"
                  label="توضیحات شغل"
                  type="text"
                />
              </div>
              <button
                type="submit"
                class="mt-6 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                ثبت اطلاعات
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </motion.div>
  );
}

export default Information;
